import { pick } from 'lodash'
import { Product } from '../../../hooks/useProduct'
import { ProductForm as ProductFormType } from '../../../redux/types/products'

const blankUpdatePayload = () => {
  return {
    name: '',
    brand: '',
    product_brand_id: null,
    description: '',
    category: '',
    root_subtype: '',
    kind: '',
    kind_subtype: '',
    amount: '',
    dosage: '',
    cbd_dosage_milligrams: '',
    thc_dosage_milligrams: '',
    net_weight_grams: '',
    quantity_value: '',
    quantity_units: '',
    aliases_attributes: [],
    image_urls: [],
  }
}

const blankCreatePayload = () => {
  return {
    name: '',
    brand: '',
    product_brand_id: null,
    description: '',
    category: '',
    root_subtype: '',
    kind: '',
    kind_subtype: '',
    amount: '',
    dosage: '',
    cbd_dosage_milligrams: '',
    thc_dosage_milligrams: '',
    net_weight_grams: '',
    quantity_value: '',
    quantity_units: '',
    aliases_attributes: [],
    image_urls: [],
    copy_attributes_from_product_id: null,
  }
}

/**
 * Takes the values from the edit product final form and transforms
 * them to the format expected by the edit product end point.
 * @param productFormValues the product form values from final form
 */
export const toProductUpdateApiFormat = (productFormValues: ProductFormType) => {
  const updateFormValues = pick(productFormValues, Object.keys(blankUpdatePayload()))

  const payload = { ...blankUpdatePayload(), ...updateFormValues }

  return payload
}

/**
 * Takes the values from the create product final form and transforms
 * them to the format expected by the create product end point.
 * @param productFormValues the product form values from final form
 * @param brands list of all brands
 * @param product the initial product
 */

export const toProductCreateApiFormat = (
  productFormValues: ProductFormType,
  product?: Pick<Product, 'id'> | null
) => {
  const createFormValues = pick(productFormValues, Object.keys(blankCreatePayload()))

  createFormValues['copy_attributes_from_product_id'] = product ? product.id : null

  const payload = { ...blankCreatePayload(), ...createFormValues }

  return payload
}
